import UAParser, {DEVICE} from 'my-ua-parser';

export const parser = new UAParser();
export const device = DEVICE;
